import { Route, Routes } from "react-router";
import ForgotPasswordSuccess from "./ForgotPasswordSuccess";
import Login from "./Login";
import LoginWrapper from "./LoginWrapper";
import MagicLogin from "./MagicLogin";
import Register from "./Register";
import RegisterSuccess from "./RegisterSuccess";

import ResetPassword from "./ResetPassword";
import VerifyEmail from "./VerifyEmail";

const LoginRoutes = () => (
	<LoginWrapper>
		<Routes>
			{ /* eslint-disable react/jsx-newline */ }
			<Route element={<Login />} path="" />
			<Route element={<MagicLogin />} path="magic" />
			<Route element={<ForgotPasswordSuccess />} path="forgot-success" />
			<Route element={<Register />} path="register/*" />
			<Route element={<RegisterSuccess />} path="register-success" />
			<Route element={<ResetPassword />} path="reset" />
			<Route element={<VerifyEmail />} path="verify-email" />
			{ /* eslint-enable react/jsx-newline */ }
		</Routes>
	</LoginWrapper>
);

export default LoginRoutes;
